import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { SingleChoiceAnswerV1, SingleChoiceAnswerV1DTO } from "../types/singleChoiceAnswerV1";
import { CommonResultBreakdownDetails, CommonResultBreakdownDetailsDTO } from "./commonResultBreakdownDetails";

export interface SingleSelectResultV1DTO {
  answer: SingleChoiceAnswerV1DTO;
  commonResultBreakdownDetails: CommonResultBreakdownDetailsDTO;
}

export class SingleSelectResultV1 {
  readonly isSingleSelectResultV1SingleSelectResultV1: boolean = true;

  readonly answer: SingleChoiceAnswerV1;
  readonly commonResultBreakdownDetails: CommonResultBreakdownDetails;


  constructor(
  answer: SingleChoiceAnswerV1, 
  commonResultBreakdownDetails: CommonResultBreakdownDetails
  ) {
    this.answer = answer;
    this.commonResultBreakdownDetails = commonResultBreakdownDetails;
  }

  static fromDTO(dto: SingleSelectResultV1DTO): SingleSelectResultV1 {
    const answer = SingleChoiceAnswerV1.fromDTO(getObject(dto, "answer", InvalidSingleSelectResultV1AnswerError));
    const commonResultBreakdownDetails = CommonResultBreakdownDetails.fromDTO(getObject(dto, "commonResultBreakdownDetails", InvalidSingleSelectResultV1CommonResultBreakdownDetailsError));
    return new SingleSelectResultV1(
      answer,
      commonResultBreakdownDetails
    );
  }

  toDTO(): SingleSelectResultV1DTO {
    const dto: SingleSelectResultV1DTO = {
        answer: this.answer.toDTO(),
        commonResultBreakdownDetails: this.commonResultBreakdownDetails.toDTO()
    };
    return dto;
  }
  }

SingleSelectResultV1.prototype.toString = function toString(): string {
  return `SingleSelectResultV1(answer='${this.answer}',commonResultBreakdownDetails='${this.commonResultBreakdownDetails}')`;
};

export class InvalidSingleSelectResultV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectResultV1Error";
  }
}
export class InvalidSingleSelectResultV1AnswerError extends InvalidSingleSelectResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectResultV1AnswerError";
  }
}

export class InvalidSingleSelectResultV1CommonResultBreakdownDetailsError extends InvalidSingleSelectResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectResultV1CommonResultBreakdownDetailsError";
  }
}
